/**
 * predictive-search-tabs.js
 *
 * The dropdown content (#predictive-search-results) is replaced wholesale
 * via innerHTML on every keystroke (see theme.js PredictiveSearch class),
 * which means any listeners attached directly to tab buttons are destroyed
 * on each re-render. Event delegation on a persistent ancestor avoids that.
 *
 * It also means we can't just render highlighted titles server-side once —
 * Shopify's predictive_search Liquid object only pre-highlights `queries`
 * (via query.styled_text); product/collection/page/article titles come back
 * plain. A MutationObserver re-highlights matches after every re-render.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-predictive-tab-target]');
    if (!btn) return;

    var scope = btn.closest('#predictive-search-results');
    if (!scope) return;

    var target = btn.getAttribute('data-predictive-tab-target');

    scope.querySelectorAll('[data-predictive-tab-target]').forEach(function (b) {
      var active = b === btn;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    scope.querySelectorAll('[data-predictive-tab-panel]').forEach(function (panel) {
      panel.classList.toggle('is-active', panel.getAttribute('data-predictive-tab-panel') === target);
    });
  });

  function getCurrentQuery() {
    var input = document.getElementById('Search');
    return input ? input.value : '';
  }

  function highlightWithin(root, query) {
    query = (query || '').trim();
    if (!query) return;
    var words = query.split(/\s+/).filter(Boolean)
      .map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
    if (!words.length) return;
    var re = new RegExp('(' + words.join('|') + ')', 'ig');

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parentTag = node.parentNode && node.parentNode.tagName;
        if (parentTag === 'MARK' || parentTag === 'SCRIPT' || parentTag === 'STYLE') {
          return NodeFilter.FILTER_REJECT;
        }
        re.lastIndex = 0;
        return re.test(node.textContent) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });

    var nodes = [];
    var n;
    while ((n = walker.nextNode())) nodes.push(n);

    nodes.forEach(function (node) {
      var text = node.textContent;
      var frag = document.createDocumentFragment();
      var lastIndex = 0;
      re.lastIndex = 0;
      var m;
      while ((m = re.exec(text))) {
        if (m.index > lastIndex) frag.appendChild(document.createTextNode(text.slice(lastIndex, m.index)));
        var mark = document.createElement('mark');
        mark.textContent = m[0];
        frag.appendChild(mark);
        lastIndex = m.index + m[0].length;
        if (m[0].length === 0) re.lastIndex++;
      }
      if (lastIndex < text.length) frag.appendChild(document.createTextNode(text.slice(lastIndex)));
      node.parentNode.replaceChild(frag, node);
    });
  }

  var resultsRoot = document.getElementById('predictive-search');
  if (resultsRoot) {
    var observer = new MutationObserver(function () {
      // Disconnect while we mutate the DOM ourselves, or the observer
      // would recursively trigger on its own <mark> insertions.
      observer.disconnect();
      highlightWithin(resultsRoot, getCurrentQuery());
      observer.observe(resultsRoot, { childList: true, subtree: true });
    });
    observer.observe(resultsRoot, { childList: true, subtree: true });
  }

  // Floating widgets (WhatsApp button, Klaviyo signup block) sit at a very
  // high z-index and poke through the search dropdown's dark overlay when
  // it's open. Toggle a body class whenever any predictive-search element
  // opens/closes (theme.js just adds/removes .is-active on itself) so CSS
  // can drop them behind the overlay for the duration — not hide them,
  // just let the overlay visually cover them like everything else on the
  // page.
  var searchElements = document.querySelectorAll('predictive-search');
  if (searchElements.length) {
    var classObserver = new MutationObserver(function () {
      var anyActive = Array.prototype.some.call(searchElements, function (el) {
        return el.classList.contains('is-active');
      });
      document.body.classList.toggle('search-popup-open', anyActive);
    });
    searchElements.forEach(function (el) {
      classObserver.observe(el, { attributes: true, attributeFilter: ['class'] });
    });
  }

})();
